<template>
  <div>
    <v-form ref="prodForm">
      <v-row>
        <v-col md="6" cols="12">
          <h3>
            <v-avatar size="25" left dark class="primary white--text">
              1
            </v-avatar>
            Datos de receta
          </h3>
          <v-tabs v-model="tab">
            <v-tab>General</v-tab>
            <v-tab>Otros Datos</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12" class="py-0 mb-n6">
                      <v-autocomplete disabled v-model="productoData.Tipo" :items="tiposProducto"
                        label="Tipo de producto" @change="$forceUpdate()" :rules="rules.Tipo" item-value="id"
                        item-text="name">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" class="mb-n6">
                      <v-text-field v-model="productoData.Nombre" :rules="rules.Nombre" label="Nombre del producto">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="mb-n6">
                      <v-autocomplete v-model="productoData.Categoria" label="Categoría del producto"
                        :items="categoriesList" :rules="rules.Categoria" item-value="id" item-text="label">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6" class="mb-n6">
                      <v-text-field v-if="!edit" v-model="productoData.Codigo" :rules="rules.Codigo"
                        label="Codigo del producto" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" md="6" class="py-0 mb-n6">
                      <v-img v-if="edit" position="right" :lazy-src="avatarUrl" height="100" width="100"
                        :src="avatarUrl"></v-img>
                      <v-btn v-if="edit" @click="
                        dialogFoto = true;
                      index++;
                      " class="primary text-center mt-2" small>
                        Cargar
                      </v-btn>

                    </v-col>

                    <v-col cols="12" md="12" class="py-0 mb-n6 mt-2">
                      <v-textarea v-model="productoData.dscr" label="Descripción"></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="py-0 mb-n4 mt-2">
                      <v-menu v-model="menuVigencia" :close-on-content-click="false" transition="scale-transition"
                        offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="vaunAux"
                            label="Fecha de vigencia (despues de la fecha el item no sera visible)"
                            prepend-icon="mdi-calendar" readonly clearable v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="vaunAux" @input="menuVigencia = false" no-title scrollable
                          color="primary"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-combobox v-model="tagSelected" :search-input.sync="search" :hide-no-data="!search"
                        :items="tags" hide-selected label="Agrega etiquetas a la receta" multiple small-chips solo>
                        <template v-slot:no-data>
                          <v-list-item>
                            <span class="subheading">Enter para agregar etiqueta</span>
                            <v-chip label small>
                              {{ search }}
                            </v-chip>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ attrs, item, parent, selected }">
                          <v-chip v-if="item === Object(item)" v-bind="attrs" :input-value="selected" label small>
                            <span class="pr-2">
                              {{ item.text }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)">
                              $delete
                            </v-icon>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ index, item }">
                          <v-text-field v-if="editing === item" v-model="editing.text" autofocus flat
                            background-color="transparent" hide-details solo
                            @keyup.enter="edit(index, item)"></v-text-field>
                          <v-chip v-else dark label small>
                            {{ item.text }}
                          </v-chip>
                          <v-spacer></v-spacer>
                          <v-list-item-action @click.stop> </v-list-item-action>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" class="py-3">
                      <div class="switch-container pa-3 rounded-lg border-subtle">
                        <v-switch v-model="productoData.opdv" label="Ocultar en el Punto de Venta" color="red darken-2"
                          hide-details inset class="mt-0 pt-0"></v-switch>
                        <div class="caption grey--text mt-1 pl-12 ml-2">
                          Si se activa, no aparecerá en las pantallas de venta.
                        </div>
                      </div>
                      <div class="switch-container pa-3 rounded-lg border-subtle">
                        <v-switch v-model="productoData.oweb" label="Ocultar en el Menú Digital" color="red darken-2"
                          hide-details inset class="mt-0 pt-0"></v-switch>
                        <div class="caption grey--text mt-1 pl-12 ml-2">
                          Si se activa, no aparecerá en los menús digitales.
                        </div>
                      </div>
                      <div class="switch-container pa-3 rounded-lg border-subtle">
                        <v-switch v-model="productoData.ocmd" label="Ocultar en el Comandero" color="red darken-2"
                          hide-details inset class="mt-0 pt-0"></v-switch>
                        <div class="caption grey--text mt-1 pl-12 ml-2">
                          Si se activa, no aparecerá en los comandero.
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-row>
            <v-col md="12" cols="12">
              <v-divider></v-divider>
              <h3>
                <v-avatar size="25" left dark class="primary white--text">
                  2
                </v-avatar>
                Departamentos y almacenes
              </h3>
            </v-col>
            <v-col cols="12" md="4" class="mb-n6">
              <v-autocomplete v-model="selectedDpto" label="Departamento" :items="modulos">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="mb-n6">
              <v-autocomplete :items="global_origen" v-model="selectedOrg" item-value="id" item-text="Nombre"
                label="Origen de inventario" />
            </v-col>
            <v-col cols="12" md="4" class="mb-n6">
              <v-btn @click="addDeptoOrg()" color="primary"> Agregar</v-btn>
            </v-col>
            <v-col md="12">
              <template v-for="(val, key) in CCs">
                <v-list :key="key">
                  <v-list-item>
                    Departamento: {{ key }} <br />Centro de consumo:
                    <template v-for="cc in val">
                      {{
                        $pgsHelper.getById(global_origen, "id", cc)
                          ? $pgsHelper.getById(global_origen, "id", cc).Nombre
                          : ""
                      }}
                    </template>
                    <v-list-item-action><v-btn @click="deleteDeptoOrg(key)" color="red"
                        dark>Eliminar</v-btn></v-list-item-action>
                  </v-list-item>
                </v-list>
              </template>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6" cols="12">
          <h3>
            <v-avatar size="25" left dark class="primary white--text">
              3
            </v-avatar>
            Insumos de la Recetas
          </h3>
          <v-btn :disabled="numberOfAlmacenes <= 0" @click="
            dialog = true;
          InsumoAdd.Cantidad = 1;
          " class="mx-2" outlined color="primary"><v-icon>mdi-plus</v-icon> Agregar Insumos</v-btn>
          <v-btn :disabled="numberOfAlmacenes <= 0" @click="deleteInsumo()" outlined
            color="red"><v-icon>mdi-delete</v-icon>
            Eliminar Insumos</v-btn>
          <h4>Insumos Agregados</h4>
          <v-autocomplete class="mb-n7 btnDeptoSelector" outlined dense @input="getCostosByDoc()"
            v-model="selectedDeptoCosteo" label="Seleccione un departamento para calcular los costos"
            :items="selectedDeptos">
          </v-autocomplete>
          <ag-grid-vue :key="tableKey" style="height: 300px" class="ag-theme-alpine" :columnDefs="columnDefs"
            rowSelection="single" :rowData="Catalogo" @cell-clicked="clickCell($event)" @gridReady="ongridReady($event)"
            @selection-changed="onSelectionChanged($event)">
          </ag-grid-vue>
          <v-divider></v-divider>
          <h3>
            <v-avatar size="25" left dark class="primary white--text">
              4
            </v-avatar>
            Costeo
          </h3>
          <v-tabs v-model="tabCosteo">
            <v-tab @click="tabCosteo = 0">Costos</v-tab>
            <v-tab @click="tabCosteo = 1">Utilidad y Margen</v-tab>
          </v-tabs>

          <v-card elevation="0" v-if="tabCosteo == 0">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" class="text-center">
                  Costo de receta:<br />
                  <h5 class="mt-n1">
                    {{
                      costeos.uct
                        ? "$" + Number(costeos.uct.C).toFixed(2)
                        : "N/A"
                    }}
                  </h5>
                </v-col>
                <v-col cols="12" md="6" class="text-center">
                  Utilidad ($)<br />
                  <h5 class="mt-n1">
                    {{
                      costeos.Ganancia
                        ? "$" + Number(costeos.Ganancia).toFixed(2)
                        : "-"
                    }}
                  </h5>
                </v-col>
              </v-row>
              <v-btn :loading="startCosteo" class="mb-4 mt-2" outlined color="primary" @click="costeo" block>
                <v-icon>mdi-calculator</v-icon>Previsualizar Costeo
              </v-btn>
              <v-simple-table v-if="costeos.costeado == false">
                <tbody>
                  <tr>
                    <td><b>Costo Insumos:</b></td>
                    <td>
                      <b>{{
                        costeos.uct
                          ? "$" + Number(costeos.uct.C).toFixed(2)
                          : "N/A"
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Costo Rendimiento:</b></td>
                    <td>
                      <b>{{
                        costeos.uct
                          ? "$" + Number(costeos.uct.C).toFixed(2)
                          : "N/A"
                      }}</b>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-alert v-if="costeos.costeado" dense text type="success">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td width="50%"><b>Costo Insumos:</b></td>
                      <td width="50%">
                        <b>{{
                          costeos.utt
                            ? "$" + Number(costeos.utt.C).toFixed(2)
                            : "N/A"
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%"><b>Costo Rendimiento:</b></td>
                      <td width="50%">
                        <b>{{
                          costeos.uct
                            ? "$" + Number(costeos.uct.C).toFixed(2)
                            : "N/A"
                        }}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-alert>
            </v-card-text>
          </v-card>
          <v-card elevation="0" v-if="tabCosteo == 1">
            <v-card-text><v-row>
                <v-col cols="12" md="12" class="mb-n6">
                  <v-row>
                    <v-col cols="12" md="4" class="mb-n6">
                      Costo de receta:<br />
                      <h5 class="mt-n1">
                        {{
                          costeos.uct
                            ? "$" + Number(costeos.uct.C).toFixed(2)
                            : "N/A"
                        }}
                      </h5>
                    </v-col>
                    <v-col cols="12" md="4" class="mb-n6">
                      Utilidad ($)<br />
                      <h5 class="mt-n1">
                        {{
                          costeos.Ganancia
                            ? "$" + Number(costeos.Ganancia).toFixed(2)
                            : "-"
                        }}
                      </h5>
                    </v-col>
                    <v-col cols="12" md="4" class="mb-n6">
                      Margen (%):<br />
                      <h5 class="mt-n1">
                        {{
                          costeos.porcentajeGanancia
                            ? "$" +
                            Number(costeos.porcentajeGanancia).toFixed(2) +
                            " %"
                            : ""
                        }}
                      </h5>
                    </v-col>
                  </v-row>
                  <v-text-field v-if="productoData.Tipo == 'AYB-Producto'" v-mask="'##'" v-model="porcentajeGanancia"
                    label="Margen de beneficio (%)" class="mt-8">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="12" class="mb-n6">
                  <v-btn :loading="startCosteo" class="mb-4" outlined color="primary" @click="costeo" block>
                    <v-icon>mdi-calculator</v-icon>Previsualizar costeo y
                    utilidad</v-btn>
                  <v-simple-table>
                    <tbody>
                      <tr>
                        <td>Costo:</td>
                        <td>
                          {{
                            costeos.uct
                              ? "$" + Number(costeos.uct.C).toFixed(2)
                              : "N/A"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Utilidad:</td>
                        <td>
                          {{ Number(ganancia.utilidad).toFixed(2) }}
                        </td>
                      </tr>
                      <tr>
                        <td>Precio Sugerido:</td>
                        <td>
                          <b>{{
                            Number(ganancia.precioSugerido).toFixed(2)
                          }}</b>
                          <v-btn v-if="ganancia.precioSugerido > 0" @click="
                            productoData.Precio = Number(
                              ganancia.precioSugerido
                            ).toFixed(2)
                            " text color="success" x-small>Utilizar</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-row class="mt-2">
            <v-col cols="12" md="12">
              <h5>Precio de producto</h5>
            </v-col>
            <v-col cols="12" md="6" class="mb-n6">
              <v-text-field v-if="productoData.Tipo == 'AYB-Producto'" v-model="productoData.Precio"
                :rules="rules.Precio" @keypress="$pgsHelper.onlyNumber($event, productoData.Precio)"
                label="Precio de Producto">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="mb-n6">
              <v-select v-if="productoData.Tipo == 'AYB-Producto'" v-model="productoData.Moneda" :rules="rules.Moneda"
                label="Tipo de moneda" item-value="id" item-text="Nombre" :items="monedas">
              </v-select>
            </v-col>
          </v-row>
          <div class="text-right mt-6">
            <v-btn large @click="$emit('toggle', false)"> Cancelar </v-btn>
            <v-btn style="margin-left: 6px" color="success" large @click="checkForm">Guardar</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Agregar Insumo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="iForm">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete :items="global_prod" item-value="id" item-text="Nombre" @change="changeProd()"
                    v-model="InsumoAdd.Id" :rules="rules.Requerido" label="Insumo o Subreceta">
                    <template v-slot:selection="data">
                      {{ data.item.Nombre }} -
                      {{
                        data.item.Extra.AYB.UM
                          ? " || Medida: " + data.item.Extra.AYB.UM
                          : ""
                      }}
                      - {{ data.item.Tipo }}
                    </template>
                    <template v-slot:item="data">
                      <v-icon v-if="!data.item.Available" color="orange">mdi-alert</v-icon>
                      <v-icon v-if="data.item.Available" color="green">mdi-check-circle</v-icon>
                      <v-list-item-content :disabled="!data.item.Available">
                        <span :class="insumoType(data.item.Tipo).color">
                          {{ data.item.Nombre }} -
                          {{
                            data.item.Extra.AYB.UM
                              ? " || Medida: " + data.item.Extra.AYB.UM
                              : ""
                          }}
                          - {{ " || Tipo: " + data.item.Tipo }} <br />
                          {{
                            !data.item.Available
                              ? "No disponible en los almacenes seleccionados: " +
                              data.item.origenesName
                              : ""
                          }}
                        </span>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field :label="'Cantidad ' + (InsumoAdd.UM ? InsumoAdd.UM : 'PZA')" :rules="rules.Requerido"
                    @keypress="
                      $pgsHelper.onlyNumber($event, InsumoAdd.Cantidad)
                      " v-model="InsumoAdd.Cantidad" type="number" required></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field label="Merma %" :rules="rules.Porcentaje"
                    @keypress="$pgsHelper.onlyNumber($event, InsumoAdd.Mm)" v-model="InsumoAdd.Mm" type="number"
                    required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="addInsumo()">
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCosteo" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Detalles de costo</span>
        </v-card-title>
        <v-card-text v-if="costoData">
          Costo con merma:
          <b v-if="costoData.ccm">{{ this.$pgsHelper.formatNumber(costoData.ccm.C) }}
            {{ costoData.ccm.M }}</b><br />
          Costo sin merma:
          <b v-if="costoData.csm">{{ this.$pgsHelper.formatNumber(costoData.csm.C) }}
            {{ costoData.csm.M }}</b><br />
          Costo Unitario:<b v-if="costoData.cst">{{ this.$pgsHelper.formatNumber(costoData.cst.C) }}
            {{ costoData.cst.M }}</b><br />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog :key="index" v-model="dialogFoto" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Cargar imagenes </v-card-title>
        <v-card-text>
          <v-btn @click="$refs.FileInput.click()" x-small color="primary">Seleccionar imagen</v-btn>
          <input ref="FileInput" type="file" style="display: none" accept="image/png, image/jpeg"
            @change="onFileSelect" />
          <vue-cropper :key="keyCropper" v-show="imgLoading" :aspect-ratio="9 / 9" preview=".preview" ref="cropper"
            :src="selectedFile"></vue-cropper>
          <v-btn-toggle v-show="imgLoading">
            <v-btn @click="rotate(90)">
              <v-icon>mdi-rotate-left</v-icon>
            </v-btn>

            <v-btn @click="zoom(-0.2)">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>

            <v-btn @click="zoom(0.2)">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="
            dialogFoto = false;
          imgLoading = false;
          ">
            Cancelar
          </v-btn>
          <v-btn :loading="loaderImage" color="green darken-1" text @click="saveImage()">
            Subir foto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Producto from "../../../clases/Producto.js";
import Currency from "../../../clases/Currencies.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProductosForm",
  components: { AgGridVue, VueCropper },
  props: ["edit", "dataEdit", "costos"],
  data() {
    return {
      costoActual: null,
      selectedDeptoCosteo: null,
      keyCropper: 0,
      editing: null,
      editingIndex: -1,
      activator: null,
      attach: null,
      search: null,
      tags: [],
      tagSelected: [],
      tab: 0,
      tabCosteo: 0,
      menuVigencia: false,
      vaunAux: null,
      selectedFile: "/assets/img/image-placeholder.png",
      avatarUrl: require("@/assets/img/image-placeholder.png"),
      index: 0,
      dialogFoto: false,
      imgLoading: false,
      loaderImage: false,
      dialogCosteo: false,
      costoData: null,
      e1: 1,
      selection: [],
      dialog: false,
      startCosteo: false,
      tableKey: 0,
      costeos: {
        costeado: false,
        cin: [],
        cmp: {},
        cmt: {},
        uct: { C: 0 },
        utt: {},
        Ganancia: null,
        porcentajeGanancia: null,
        utilidad: 0,
        precioSugerido: 0,
      },
      productoData: new Producto(),
      initInv: false,
      Categories: [],
      errors: {},
      monedas: Currency.getCurrencies(),
      tiposProducto: Producto.getTiposProducto(),
      loader: true,
      rules: Producto.getRules(),
      columnDefs: null,
      rowData: null,
      addingData: 1,
      Catalogo: [],
      CCs: {},
      selectedDpto: "",
      selectedOrg: "",
      porcentajeGanancia: 0,
      InsumoAdd: {
        Nombre: "",
        Id: "",
        Tipo: "",
        Cantidad: 1,
        //Precio: 0,
        Mm: 0,
        Moneda: this.$Currencies.getCurrencyDefault(),
        Catalogo: [],
        Extra: {},
      },
      Extra: {
        AYB: {
          UM: "",
          Rm: 1,
        },
      },
    };
  },
  methods: {
    costeoBySelectedDepto() {
      let costeo = null;
      let costo = this.$pgsHelper.getById(
        this.costoActual,
        "depto",
        this.selectedDeptoCosteo
      );
      if (costo) {
        costeo = (costo.uct) ? costo.uct : costo.cto;
        this.costeos.uct.C = costeo.C;
      } else {
        this.costeos.uct.C = 0;
      }
      this.costeos.Ganancia =
        Number(this.productoData.Precio) - Number(this.costeos.uct.C);
      if (
        this.productoData.Precio != "" &&
        Number(this.productoData.Precio) != 0
      ) {
        let porcentajeGanancia =
          (1 - Number(this.costeos.uct.C) / Number(this.productoData.Precio)) *
          100;
        this.costeos.porcentajeGanancia = porcentajeGanancia;
      } else {
        this.costeos.porcentajeGanancia = null;
      }
      this.$forceUpdate();
    },
    getCostosByDoc() {
      this.Catalogo.forEach((insumo) => {
        let costoData = this.costos[insumo.Id];
        if (costoData) {
          let costoDeptoSelected = this.$pgsHelper.getById(
            costoData,
            "depto",
            this.selectedDeptoCosteo
          );
          if (costoDeptoSelected) {
            insumo.costoData = costoDeptoSelected;
            insumo.Costo = Number(
              this.$pgsHelper.roundNumber(
                costoDeptoSelected.uct.C * insumo.Cantidad
              )
            );
            insumo.CostoMoneda = costoDeptoSelected.uct.M;
          }
        }
      });
      this.costeoBySelectedDepto();
    },
    getImg(imgUrl) {
      this.keyCropper++;
      let app = this.$store.getters.getFirebaseApp;
      const storage = getStorage(app.mainApp);
      getDownloadURL(ref(storage, imgUrl))
        .then((url) => {
          this.avatarUrl = url;
          this.keyCropper++;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      this.mime_type = file.type;

      if (typeof FileReader === "function") {
        this.dialogFoto = true;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.selectedFile = event.target.result;

          this.imgLoading = true;
          this.$refs.cropper.replace(this.selectedFile);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      var ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var blob = new Blob([ab], { type: mimeString });
      return blob;
    },
    saveImage() {
      this.loaderImage = true;
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();

      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        const formData = new FormData();
        formData.append("ProductoId", this.productoData.Id);
        formData.append("Tenant", this.$store.getters.getFirebaseApp.tenant);

        formData.append(
          "Foto",
          this.dataURItoBlob(this.cropedImage),
          "Avatar." + this.mime_type.replace(/(.*)\//g, "")
        );

        this.$store.getters.getFirebaseApp.fba
          .callForm("PDV-Productos-uploadProductoFoto", formData, {
            "Content-Type": "multipart/form-data",
          })
          .then((result) => {
            this.loaderImage = false;
            if (result.data.ok) {
              this.dialogFoto = false;
              this.imgLoading = false;
              this.avatarUrl = this.cropedImage;
              this.$swal("Éxito", "Foto actualizada correctamente", "success");
            } else {
              this.$swal("Error", "No se pudo subir la foto", "error");
            }
          })
          .catch((error) => {
            this.loaderImage = false;
            this.$swal("Error", `Request failed: ${error}`, "error");
          });
      }, this.mime_type);
    },
    clickCell(CellClickedEvent) {
      if (CellClickedEvent.colDef.field == "Costo") {
        if (CellClickedEvent.data.costoData) {
          this.costoData = CellClickedEvent.data.costoData;
          this.dialogCosteo = true;
        } else {
          this.costoData = null;
        }
      }
    },
    async costeo() {
      this.startCosteo = true;
      let dptos = Object.entries(this.CCs);
      if (dptos.length > 0) {
        let datos = {
          type: "INSUMOS",
          departamento: dptos[0][0],
          costoAdicional: 0,
          rendimiento: 1,
          porciones: 1,
          insumos: [],
        };
        this.Catalogo.forEach((ins) => {
          datos.insumos.push({
            ins: ins.Id,
            cnt: Number(ins.Cantidad),
            mrm: Number(ins.Mm),
          });
        });
        await this.$store.getters.getFirebaseApp.fba
          .call("AYB-Costeo-costearReceta", datos)
          .then((result) => {
            this.startCosteo = false;
            this.costeos = result.data.data;
            if (this.costeos?.cin.length > 0) {
              this.costeos.cin.forEach((costoInsumo) => {
                let insumo = this.$pgsHelper.getById(
                  this.Catalogo,
                  "Id",
                  costoInsumo.ins
                );
                if (insumo) {
                  this.Catalogo[insumo.idx].costoData = costoInsumo;
                  this.Catalogo[insumo.idx].Costo = Number(
                    this.$pgsHelper.roundNumber(costoInsumo.uct.C)
                  );
                  this.Catalogo[insumo.idx].CostoMoneda = costoInsumo.uct.M;
                }
              });
            }
            this.costeos.costeado = true;
            this.costeos.Ganancia =
              Number(this.productoData.Precio) - Number(this.costeos.uct.C);
            if (
              this.productoData.Precio != "" &&
              Number(this.productoData.Precio) != 0
            ) {
              let porcentajeGanancia =
                (1 -
                  Number(this.costeos.uct.C) /
                  Number(this.productoData.Precio)) *
                100;
              this.costeos.porcentajeGanancia = porcentajeGanancia;
            } else {
              this.costeos.porcentajeGanancia = null;
            }
            this.$forceUpdate();
            this.tableKey++;
          })

          .catch((error) => {
            console.log(error);
            this.startCosteo = false;
          });
      }
    },
    changeProd() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.InsumoAdd.Id
      );
      this.InsumoAdd.Mm = prod?.Extra?.AYB?.Mm || 0;
      this.InsumoAdd.UM = prod?.Extra?.AYB?.UM || "PZA";
    },
    addDeptoOrg() {
      this.CCs[this.selectedDpto] = [this.selectedOrg];

      this.addingData++;
      this.$forceUpdate();
    },
    deleteDeptoOrg(id) {
      delete this.CCs[id];
      this.addingData++;
      this.$forceUpdate();
    },
    deleteInsumo() {
      this.selection.forEach((selectProd) => {
        let prod = this.$pgsHelper.getById(this.Catalogo, "Id", selectProd.Id);
        if (prod) {
          this.Catalogo.splice(prod.idx, 1);
        }
      });
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();

      this.selection = selectedRows;
    },
    ongridReady: function (params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    checkForm: function (e) {
      if (this.$refs.prodForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          if (this.productoData.Tipo != "AYB-Producto") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
          }
          doAction = "EDIT";
        } else {
          if (this.productoData.Tipo != "AYB-Producto") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
          }
        }
        if (this.productoData.Precio == "") {
          this.productoData.Precio = 0;
          this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
        }
        this.productoData.Extra = this.Extra;
        let deptos = Object.entries(this.CCs);
        let departamentos = [];
        deptos.forEach((depto) => {
          departamentos.push(depto[0]);
        });
        this.productoData.Departamentos = departamentos;
        this.productoData.CCs = [this.CCs];
        this.productoData.Extra.AYB.Rm = Number(this.productoData.Extra.AYB.Rm);
        this.Catalogo.forEach((prod) => {
          prod.Cantidad = Number(prod.Cantidad);
          prod.Extra.AYB.Mm = Number(prod.Mm || 0);
        });
        this.productoData.Catalogo = this.Catalogo;
        let tags = [];
        this.tagSelected.forEach((item) => {
          tags.push(item.text);
        });
        this.productoData.tags = tags;
        if (this.vaunAux) {
          const dateObj = new Date(this.vaunAux + 'T00:00:00');
          this.productoData.Vaun = dateObj.getTime();
        } else {
          this.productoData.Vaun = null;
        }
        this.$emit("successData", this.productoData, doAction);
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    addInsumo() {
      if (this.$refs.iForm.validate()) {
        let prod = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          this.InsumoAdd.Id
        );
        if (prod) {
          this.InsumoAdd.Catalogo = prod.Catalogo || [];
          this.InsumoAdd.Tipo = prod.Tipo || "";
          this.InsumoAdd.Nombre = prod.Nombre || "";
          this.InsumoAdd.Extra = prod.Extra || null;
          this.InsumoAdd.UM = prod.Extra.AYB.UM;
        }

        this.Catalogo.push(this.$pgsHelper.cloneObj(this.InsumoAdd));
        this.dialog = false;
      }
    },
    insumoType(selectedType) {
      console.log("Tipo", selectedType);
      const types = [
        {
          type: "AYB-Insumo",
          color: "primary--text",
        },
        {
          type: "AYB-ICompuesto",
          color: "orange--text text-darken-1",
        },
      ];

      return types.filter((insumo) => insumo.type == selectedType)[0];
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    selectedDeptos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      this.addingData;
      if (this.productoData.Departamentos.length > 0) {
        departamentos.forEach((element) => {
          if (this.productoData?.Departamentos.includes(element.id)) {
            dep.push({ value: element.id, text: element.Nombre });
          }
        });
      }

      return dep;
    },
    ganancia() {
      let precios = {
        utilidad: 0,
        precioSugerido: 0,
      };
      let costoreceta = this.costeos?.uct?.C || 0;
      let precio = costoreceta / (1 - Number(this.porcentajeGanancia) / 100);
      precios.precioSugerido = precio;
      precios.utilidad = precio - costoreceta;
      return precios;
    },
    numberOfAlmacenes() {
      this.addingData;
      let almacenes = Object.entries(this.CCs);
      return almacenes.length;
    },
    global_origen() {
      let ori = this.$store.getters.getCentrosConsumo;
      /*prod.forEach((element)=>{
            element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        })*/
      return ori;
    },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    categoriesList() {
      let categories = [];
      if (this.productoData.Departamentos.length > 0) {
        this.Categories.forEach((categoria) => {
          this.productoData.Departamentos.forEach((modulo) => {
            if (modulo == categoria.Departamento) {
              categories.push(categoria);
            }
          });
        });
        return categories;
      } else {
        return this.Categories;
      }
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        if (
          (element.Tipo == "AYB-Insumo" || element.Tipo == "AYB-ICompuesto") &&
          !element.Dlat
        ) {
          //element.disabled= true
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      productos.forEach((producto) => {
        let invData = [];
        let availablesOrigenes = {};
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            availablesOrigenes[origen.Origen] = origen.nombreOrigen;
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              NombreOrigen: origen.nombreOrigen,
            });
          }
        });
        producto.availablesOrigenes = availablesOrigenes;
        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
      });

      productos.forEach((prod) => {
        let existInAll = false;
        let cantExist = 0;
        let origenesName = "";
        let almacenes = Object.entries(this.CCs);
        let origenesData = this.$store.getters.getCentrosConsumo;
        almacenes.forEach((origen) => {
          if (prod.availablesOrigenes[origen[1][0]]) {
            cantExist++;
          } else {
            let itemIndexOrigen = this.$_.findIndex(origenesData, {
              id: origen[1][0],
            });
            let name = origenesData[itemIndexOrigen]?.Nombre;
            origenesName = origenesName + name + ", ";
          }
        });
        if (cantExist !== almacenes.length) {
          prod.disabled = false;
          prod.Available = true;
          prod.origenesName = origenesName;
        } else {
          prod.disabled = false;
          prod.Available = true;
        }
      });
      // console.log("Productos", productos);
      return productos;
    },
  },
  watch: {
    tagSelected(val, prev) {
      if (val.length === prev.length) return;

      this.tagSelected = val.map((v) => {
        if (typeof v === "string") {
          v = {
            text: v,
            color: "primary",
          };

          this.tags.push(v);

          this.nonce++;
        }

        return v;
      });
    },
  },
  beforeMount: function () { },
  mounted() {
    this.getCategories();
    this.loader = false;
    this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
    if (this.edit) {
      this.costoActual = this.dataEdit.Costeo;
      this.productoData = new Producto(this.dataEdit);
      this.Extra.AYB = this.productoData?.Extra?.AYB;
      this.productoData.Catalogo.forEach((prod) => {
        let producto = this.$pgsHelper.getById(this.global_prod, "id", prod.Id);
        prod.Nombre = producto.Nombre;
        prod.UM = prod.Extra.AYB.UM;
        prod.Mm = prod.Extra.AYB.Mm;
      });
      this.selectedDeptoCosteo = this.productoData.Departamentos[0];
      this.Catalogo = this.productoData.Catalogo;
      if (this.productoData.CCs) {
        this.CCs = this.productoData.CCs[0] || {};
      } else {
        this.CCs = {};
      }
      if (this.productoData.imgn) {
        let url =
          this.$store.getters.getFirebaseApp.tenant +
          "/PDV_Productos/" +
          this.productoData.Id +
          "/foto.jpg";
        this.getImg(url);
      }
      this.keyCropper++;
      this.getCostosByDoc();
      if (this.productoData.Vaun) {
        const dateVal = Number(this.productoData.Vaun);
        if (!isNaN(dateVal)) {
          const dateObj = new Date(dateVal);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          this.vaunAux = `${year}-${month}-${day}`;
        } else {
          this.vaunAux = this.productoData.Vaun;
        }
      }
    }

    this.tagSelected = this.productoData.tags;
    this.productoData.Tipo = "AYB-Producto";

    this.columnDefs = [
      { field: "Tipo" },
      { field: "Nombre", width: 500 },
      {
        field: "Cantidad",
        editable: true,
        valueFormatter: (params) => params.data.Cantidad + " " + params.data.UM,
      },
      {
        field: "Costo",
        editable: false,
        cellClassRules: {
          CosteoError: "value===0",
        },
        valueFormatter: (params) =>
          params.data.Costo != null ? params.data.Costo : "-",
      },
    ];

    /* this.rowData = [
      { Tipo: "Insumo", model: "Celica", price: 35000 },
      { Tipo: "Ford", model: "Mondeo", price: 32000 },
      { Tipo: "Porsche", model: "Boxster", price: 72000 },
    ];*/
  },
};
</script>
<style>
.CosteoError {
  background: #ff00007a;
}
</style>
